import { Injectable, NgModule, inject } from '@angular/core';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CorePageModule,
  CorePageModuleIDs,
  CoreSelectorGuard,
  CoreUtils,
  CoreUtilsService
} from '@bepatient/core';
import {
  FactsheetActionLoadFactsheet,
  selectorFactsheetFactsheet
} from '@bepatient/factsheet-store';
import { Store } from '@ngrx/store';

@Injectable()
export class FactsheetGuard extends CoreSelectorGuard {
  constructor() {
    const store = inject<Store<any>>(Store);

    super(
      store,
      selectorFactsheetFactsheet,
      new FactsheetActionLoadFactsheet()
    );
  }
}

const factsheetModule: CorePageModule = {
  ID: CorePageModuleIDs.FACTSHEET,
  i18nLabel: 'MODULES.FACTSHEET',
  icon: 'clipboard',
  leftMenuAvailableForDepthModules: true,
  routes: CoreUtils.generateDepthModuleRoutes(
    'factsheet',
    () =>
      import('./pages/factsheet/factsheet.module').then(
        module => module.FactsheetPageModule
      ),
    FactsheetGuard
  )
};

@NgModule({
  providers: [
    FactsheetGuard,
    { provide: CORE_PAGE_MODULE, useValue: factsheetModule, multi: true },
    { provide: CORE_I18N_FOLDER, useValue: './factsheet/i18n/', multi: true }
  ]
})
export class FactsheetModule {
  constructor() {
    const coreUtilsService = inject(CoreUtilsService);

    coreUtilsService.addDepthModuleRoutes(factsheetModule);
  }
}
